<template>
    <div class="w-100 d-flex align-items-center">
        <div class="mr-1">
            <feather-icon
                icon="GitMergeIcon"
                size="16"
            />
        </div>
        <div class="w-100">Insert intermediate component</div>
        <div>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon"
                size="sm"
                @click="$emit('insert')"
            >
                <feather-icon
                    icon="PlusIcon"
                />
            </b-button>
        </div>
    </div>
</template>

<script>
import {BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    directives: {Ripple},
    components: {BButton}
}
</script>
